import { store } from '../core/redux/store'; // Adjust the path to your store
import { selectHasAccessFunction, selectHasAccessModule } from '../core/redux/store/userSlice/userSlice';

const userRoleCache = new Map<string, any>();

const memoizeUserRole = () => {
    if(!userRoleCache.has('data')){
        userRoleCache.set('data', {
            role: store.getState()?.user?.role,
            actions: store.getState()?.user?.actions
        });
    }
};

export const clearUserRoleCache = () => {
    userRoleCache.clear();
};

export const checkHasAccessFunction = (method: string): boolean => {

    memoizeUserRole();
    const state = userRoleCache.get('data');
    const result = selectHasAccessFunction(state, method);
    return result;
};

export const checkHasAccessModule = (path) => {
    memoizeUserRole();
    const state = userRoleCache.get('data');
    return selectHasAccessModule(state, path);
}